import React from "react";
import CountUp from "react-countup";

export type Props = {
	decimals?: boolean;
	sum?: string | number;
	isPersent?: boolean;
	sumColor?: string;
	comCount?: boolean;
	prefix?: string;
	className?: any;
};
const CountUpComp = ({ decimals, sum, sumColor, comCount, prefix, className }: Props) => {
	return (
		<CountUp decimals={decimals ? 1 : 0} decimal={","} delay={0} end={Number(sum)} separator=" " duration={1}>
			{({ countUpRef }) => (
				<div className={className}>
					<span style={{ color: sumColor }} ref={countUpRef} />
					{comCount && (
						<span style={{ color: sumColor }} className={"pl-5"}>
							/ {Number(comCount).toLocaleString()}
							{prefix}
						</span>
					)}
					<span style={{ color: sumColor, fontSize: "18px", marginLeft: "5px" }}>{prefix}</span>
				</div>
			)}
		</CountUp>
	);
};
export default CountUpComp;
